var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['core', 'jquery', 'underscore', 'backbone'], function(core, $, _, Backbone) {
  var BaseView;
  return BaseView = (function(_super) {

    __extends(BaseView, _super);

    function BaseView() {
      BaseView.__super__.constructor.apply(this, arguments);
    }

    BaseView.prototype.sanitize = function(text) {
      return text.replace(/<br>/gi, '\n').replace(/<\/?[^>]+>/gi, '');
    };

    BaseView.prototype.destroy = function() {
      this.undelegateEvents();
      this.$el.removeData().unbind();
      return this.remove();
    };

    return BaseView;

  })(Backbone.View);
});
